import { AppRoutes } from '@constants';

export interface NavListItem {
  name: string;
  url: string;
  enabled: boolean;
  active: boolean;
}

export const NAV_ITEM_LIST: NavListItem[] = [
  {
    name: 'Seguimiento',
    url: AppRoutes.TRACKING,
    enabled: true,
    active: false,
  },
  {
    name: 'Chat',
    url: AppRoutes.CHATS,
    enabled: true,
    active: false,
  },
  {
    name: 'Clientes',
    url: AppRoutes.CLIENTS,
    enabled: true,
    active: false,
  },
  {
    name: 'Dashboard',
    url: AppRoutes.DASHBOARD_TABLE,
    enabled: true,
    active: false,
  },
  {
    name: 'Correo',
    url: AppRoutes.EMAIL,
    enabled: true,
    active: false,
  },
];

export enum TabNames {
  FOLLOW_UP = 'orders-follow-up',
  CHAT = 'orders-follow-up-chats',
  DASHBOARD = 'dashboard',
}

export const TAB_MAP: Record<string, TabNames> = {
  Seguimiento: TabNames.FOLLOW_UP,
  Chat: TabNames.CHAT,
  Dashboard: TabNames.DASHBOARD,
};
